import * as React from 'react';
import { AppProvider } from '@toolpad/core/AppProvider';
import { SignInPage } from '@toolpad/core/SignInPage';
import { useTheme } from '@mui/material/styles';
import { useAuth } from '../components/AuthProvider';

// preview-start
const providers = [{ id: 'credentials', name: 'Email and Password' }];
// preview-end

export default function LoginPage() {
	const theme = useTheme();

	return (
		<AppProvider theme={theme}>
			<SignInPage
				signIn={useAuth().loginAction}
				providers={providers}
				slotProps={{ emailField: { autoFocus: false } }}
			/>
		</AppProvider>
	);
}
